import { Page, Text, View, Document, Font, Image } from "@react-pdf/renderer";
import { styles } from "./styles";
import { PdfTemplateElements } from "@/components/RecipeComponents/RecipePdfTemplate/RecipePdfTemplate";
import { PrintListItem } from "@/components/RecipeComponents/RecipeSingleView/PDFDownloadButton/PDFDownloadButton";
import { StepZutatList } from "@/types/baseTypes";

/* jscpd:ignore-start */
Font.register({
  family: "Proxima Nova Regular",
  src: "https://api.kleine-tiptopf.aleksundshantu.com/wp-content/uploads/2024/11/proximanova-regular-webfont.woff",
});

Font.register({
  family: "Proxima Nova Bold",
  src: "https://api.kleine-tiptopf.aleksundshantu.com/wp-content/uploads/2024/11/proximanova-bold-webfont.woff",
});
/* jscpd:ignore-end */

export const ShoppingListPdfTemplate = ({
  recipes,
  elements,
}: {
  recipes: PrintListItem[];
  elements: PdfTemplateElements;
}) => {
  return (
    <Document>
      {recipes.map((recipe, i) => {
        const ingredients = (recipe.item as StepZutatList).zutaten_portion_big;

        // const tipp = recipe.item.rezept_tipp;

        return (
          <Page style={styles.body} key={i}>
            <View style={styles.header}>
              <View style={styles.headerTitleCol}>
                {/* @react-pdf/renderer Image does not need alt text */}
                {/*eslint-disable-next-line jsx-a11y/alt-text */}
                <Image style={styles.logo} src={elements.logo} />
                <Text style={styles.title}>{"Einkaufsliste"}</Text>
              </View>
              {/* <View style={styles.logoCol}> */}
              {/* @react-pdf/renderer Image does not need alt text */}
              {}
              {/* <Image style={styles.logo} src={elements.logo} /> */}
              {/* </View> */}
              <View style={styles.headerImgCol}>
                {recipe.base64 && (
                  /* @react-pdf/renderer Image does not need alt text */
                  /* eslint-disable-next-line jsx-a11y/alt-text */
                  <Image style={styles.image} src={recipe.base64} />
                )}
              </View>
            </View>
            <View style={styles.recipeHeader}>
              <Text style={styles.recipeTitle}>{recipe.item.rezept_titel}</Text>
            </View>
            <View style={styles.mainView}>
              <View style={styles.recipeView}>
                <Text style={styles.portion}>
                  {recipe.item.portionsgroesse ||
                    recipe.item.anzahl_portionen_big + " " + "Portionen"}
                </Text>
                {ingredients &&
                  ingredients.map((step, i) => {
                    const stepAmount = step.step_zutat_menge;
                    return step.zutat_namen !== "" ? (
                      <View key={i} style={styles.recipeLine}>
                        <Text style={styles.checkbox}></Text>
                        <Text style={styles.amountCol}>
                          {stepAmount !== 0 ? stepAmount + " " : ""}
                          {step.step_zutat_masseinheit_abkuerzung
                            ? step.step_zutat_masseinheit_abkuerzung + " "
                            : ""}
                          {step.zutat_namen}
                        </Text>
                      </View>
                    ) : null;
                  })}
              </View>
              <View style={styles.notizenView}>
                <Text style={styles.notizenTitle}>{"Notizen"}</Text>
                <Text style={styles.notizenLines} />
                <Text style={styles.notizenLines} />
                <Text style={styles.notizenLines} />
                <Text style={styles.notizenLines} />
                <Text style={styles.notizenLines} />
                <Text style={styles.notizenLines} />
              </View>
            </View>
            {/* <View style={styles.noticeView}>
           
              <Image style={styles.infoImage} src={InfoIcon.src} />
              <View style={styles.noticeText}>
                {noticeFormat(conversionNotice).map((block, i) => {
                  return i % 2 === 0 ? (
                    <Text key={i} style={styles.notice}>
                      {block}
                    </Text>
                  ) : (
                    <Text key={i} style={styles.noticeStrong}>
                      {block}
                    </Text>
                  );
                })}
              </View>
            </View> */}

            {/* {tipp && tipp.replace(/<[^>]*>/g, "") !== "" && (
              <>
                <View style={styles.tippView}>
                  <Text style={styles.tippLabel}>Tipps</Text>
                </View>
                <View style={styles.tippLine}>
                  <Text style={styles.redDot} />
                  <Text style={styles.rezeptTipp}>
                    {tipp && tipp.replace(/<[^>]*>/g, "")}
                  </Text>
                </View>
              </>
            )} */}
            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
              fixed
            />
          </Page>
        );
      })}
    </Document>
  );
};
